import {combineReducers} from 'redux';
import {filterActions} from 'redux-ignore';
import Const from 'constants';
import playersData from './players';
import lineupsData from './lineups';
import modal from './modal';
import stacks from './stacks';
import sportConfig from './sport-config';
import lineupGenerator from './lineup-generator';
import reset from './reset';
import messagesData from './messages';
import optimizationConfig from './optimization-config';
import optimization from './optimization';
import lineupTeamsCombinations from './lineup-teams-combinations';
import lineupTeamsStacks from './lineup-teams-stacks';
import usedTeams from './used-teams';
import correlationStacking from './correlation-stacking/index';
import runSettings from './run-settings';
import playersLock from './players-lock';
import playersExclusion from './players-exclusion';
import playersSympathy from './players-sympathy';
import pointsBoundary from './points-boundary';
import salaryBoundary from './salary-boundary';
import salaryCap from './salary-cap';
import projectedOwnershipCap from './projected-ownership-cap';
import teamNameStacking from './team-name-stacking';
import playerNameStacking from './player-name-stacking';
import playerPositionStacking from './player-position-stacking';
import cptPositionStacking from './cpt-position-stacking';
import usedPlayers from './used-players';
import modesConfig from './modes-config';
import playerSettingPopup from './player-setting-popup';
import teamsInfo from './teams';
import exposureMode from './exposure-mode';
import projectionPointsType from './projection-points-type';
import userPointsType from './user-points-type';
import uniquePlayersQuantity from './unique-players-quantity';
import rangeOfOutcomes from './range-of-outcomes/range-of-outcomes';
import rangeOfOutcomesByPositions from './range-of-outcomes/range-of-outcomes-by-positions';
import lineupsQuantity from './lineups-quantity';
import nonControlledHitterStacking from './non-controlled-hitter-stacking';
import randomTeamStacking from './random-team-stacking';
import competitionStacking from './competition-stacking';
import opposingPitchers from './opposing-pitchers';
import dominatorStacking from './dominator-stacking';
import playerCombinationStacking from './player-combination-stacking';
import keyPlayerStacking from './key-player-stacking/index';
import projectedOwnershipForce from './projected-ownership-force';
import socketIO from './socket-io';
import filterLineupsByPlayer from './filter-lineups/filter-lineups-by-player';
import lineupPlayerMap from './lineups-map/lineup-player-map';
import lateSwap from './late-swap';
import lineupResolvingProcess from './lineup-resolving-process';
import swappedPlayers from './swapped-players';
import singlegameForcedStacking from './singlegame-forced-stacking';
import nhlTeamStacking from './nhl-team-stacking';
import nhlLegacyTeamStacking from './nhl-legacy-team-stacking';
import f1PerTeamDriverLimits from './f1-per-team-driver-limits';
import filterLineupsByTeamCombinations from './filter-lineups/filter-lineups-by-team-combinations';
import lineupTeamCombinationsMap from './lineups-map/lineup-team-combinations-map';
import filterLineupsByCorrelationStackCombinations from './filter-lineups/filter-lineups-by-correlation-stack-combinations';
import lineupCorrelationStackCombinationsMap from './lineups-map/lineup-correlation-stack-combinations-map';
import projectionBoostRule from './projection-boost-rule';
import playerGroupingsSwitch from './player-groupings-switch';
import filterLineupsByKeyPlayerStackCombinations from './filter-lineups/filter-lineups-by-key-player-stack-combinations';
import lineupKeyPlayerStackCombinationsMap from './lineups-map/lineup-key-player-stack-combinations-map';
import playersDropzone from './players-dropzone';
import theme from './theme';
import randomPoints from './random-points';

const reducers = {
    lateSwap: filterActions(lateSwap, [
        Const.LATESWAP_SET_IS_USED,
        Const.LATESWAP_SET_UPLOADED_CSV_DATA,
        Const.LATESWAP_SET_CSV_LINEUPS,
        Const.LATESWAP_SET_SIMPLEX_LINEUPS,
        Const.LATESWAP_SET_LINEUP_VIEWS,
        Const.LATESWAP_SET_LINEUPS_USED_PLAYERS,
        Const.LATESWAP_SET_LOADING_STATUS,
        Const.LATESWAP_SET_CREATED_LINEUPS_MAP,
        Const.LATESWAP_GROUP_SAME_LINEUPS,
        Const.FILTER_BY_SLATE,
        Const.OPTIMIZATION_START,
        Const.RESET_ALL_SETTINGS,
    ]),
    lineupResolvingProcess: filterActions(lineupResolvingProcess, [Const.SET_LINEUP_RESOLVING_PROCESS_DATA]),
    swappedPlayers: filterActions(swappedPlayers, [
        Const.SWAPPED_PLAYERS_SET_LAST_UPDATED_LINEUP_ID,
        Const.FILTER_BY_SLATE,
        Const.OPTIMIZATION_START,
    ]),
    socketIO: filterActions(socketIO, [Const.SOCKET_SUBSCRIBE, Const.SOCKET_UNSUBSCRIBE, Const.FILTER_BY_SLATE]),
    playersData: filterActions(playersData, [
        Const.SET_GAMES_FILTER,
        Const.SET_PLAYER_POSITIONS_FILTER,
        Const.SET_PLAYER_CONFIRMED_FILTER,
        Const.FILTER_BY_PLAYER_SALARY_FILTER,
        Const.FILTER_BY_CAPTION_SALARY_FILTER,
        Const.FILTER_BY_USER_POINTS_FILTER,
        Const.FILTER_BY_CAPTION_USER_POINTS_FILTER,
        Const.FILTER_BY_STAR_USER_POINTS_FILTER,
        Const.FILTER_BY_PRO_USER_POINTS_FILTER,
        Const.FILTER_BY_PLAYERS_TYPE,
        Const.FILTER_BY_PLAYER_NAME,
        Const.FILTER_BY_TEAM,
        Const.SET_PLAYERS_SORT_BY,
        Const.SET_HITTERS_ORDER,
        Const.SET_LINE_GROUPS,
        Const.FILTER_BY_TIERS_SET_UNUSED_TIER_NUMBER,
        Const.SET_PLAYER_TIERS_FILTER,
        Const.SET_FLEX_MAX_EXPOSURE_POSITION,
        // Const.RESET_FLEX_MAX_EXPOSURE_POSITION,
        Const.SET_SUPERFLEX_MAX_EXPOSURE_POSITION,
        // Const.RESET_SUPERFLEX_MAX_EXPOSURE_POSITION,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
        Const.SET_IS_PLAYERS_GROUP_READY,
        Const.GET_PLAYERS_SUCCESS,
        Const.DELETE_PLAYERS_BY_IDS,
        Const.UNSET_PLAYERS,
        Const.EXCLUDE_PLAYERS_NOT_IN_ORDER_RANGE,
        Const.EXCLUDE_PLAYERS_NOT_IN_CONFIRMED_RANGE,
        Const.EXCLUDE_PLAYERS_NOT_IN_LINE_GROUPS,
        Const.RESET_EXCLUDE_PLAYERS_BY_RANGE,
        Const.LOCKING_SET_PLAYERS,
        Const.UPDATE_PLAYER_PARAMS,
        Const.RESET_PP_LINE,
        Const.RESET_PLAYERS_LINE_GROUPS,
        Const.SET_DOMINATOR,
        Const.SET_PLAYERS_LINE_GROUP,
        Const.SET_PLAYERS_PP_LINE,
        Const.SET_PLAYERS_POINTS,
        Const.SET_PLAYERS_SCORES,
        Const.SET_PLAYERS_EXPOSURE,
        Const.SET_PLAYERS_COUNTERS,
        Const.SET_PLAYERS_PROJECTED_OWNERSHIP_FROM_CSV,
        Const.SET_PLAYERS_PROJECTED_OWNERSHIP_FROM_STORAGE,
        Const.SET_PREPARED_PLAYERS_LIST,
        Const.GET_GAMES_SUCCESS,
        Const.GET_SLATE_REQUEST,
        Const.GET_SLATE_FAILURE,
        Const.SET_TEAM_DETAILS,
        Const.UNSET_TEAM_DETAILS,
        Const.GET_SLATES_REQUEST,
        Const.GET_SLATES_SUCCESS,
        Const.UPDATE_SLATE,
        Const.GET_SLATES_FAILURE,
        Const.UNSET_SLATES,
        // Const.SET_RANDOM_POINTS,
        // Const.UNSET_RANDOM_POINTS,
        Const.FILTER_BY_MODE,
        Const.FILTER_BY_SITE,
        Const.FILTER_BY_SPORT,
        Const.FILTER_BY_GAME_TYPE,
        Const.FILTER_BY_SLATE,
        Const.CHANGE_PLAYERS_POSITION,
    ]),
    randomPoints: filterActions(randomPoints, [
        Const.SET_RANDOM_POINTS,
        Const.UNSET_RANDOM_POINTS,
    ]),
    lineupsData: filterActions(lineupsData, [
        Const.SET_OPPOSING_PLAYERS,
        Const.SET_USE_OPPOSING_GOALIE,
        Const.SET_ALLOW_OPPOSING_TEAMS_IN_LINEUP,
        Const.SET_ALLOW_ONLY_ONE_K_POSITION_PER_LINEUP,
        Const.SET_ALLOW_ONLY_ONE_DST_POSITION_PER_LINEUP,
        Const.SET_AVOID_FEW_PASS_RECEIVERS,
        Const.SET_LIMIT_ONE_PITCHER_PER_GAME,
        Const.SET_PRIORITIZE_COMPLETING_LINEUPS_ABOVE_EXP_MAX,
        Const.LINEUPS_LIST_SET_IS_CHECKED,
        Const.RESET_LINEUPS_FILTERS,
        Const.LINEUPS_LIST_SET_SORT,
        Const.SET_DEFAULT_VALUES_FOR_LINEUPS_FILTERS,
        Const.GET_LINEUPS_REQUEST,
        Const.RESET_ALL_SETTINGS,
        Const.GET_LINEUPS_REQUEST,
        Const.GET_LINEUPS_SUCCESS,
        Const.UNSET_LINEUPS,
        Const.LINEUP_SET_IS_CHECKED,
        Const.LINEUP_REMOVE,
        Const.LINEUPS_LIST_REMOVE_CHECKED,
        Const.SET_RAW_LINEUP,
        Const.UNSET_RAW_LINEUPS,
        Const.LINEUP_REMOVE,
        Const.LINEUPS_LIST_REMOVE_CHECKED,
        Const.SET_STATUS_OF_LINEUPS_IS_FILLED,
        Const.F1_STACK_CAPTAIN_TO_CONSTRUCTOR,
        Const.STACK_QUARTERBACK_WITH_PASS_CATCHERS,
    ]),
    modal: filterActions(modal, [Const.OPEN_MODAL, Const.CLOSE_MODAL]),
    stacks: filterActions(stacks, [
        Const.NHL_NON_CONTROLLED_STACK_IS_USED,
        Const.SET_NON_CONTROLLED_STACK,
        Const.REMOVE_NON_CONTROLLED_STACK,
        Const.NHL_NAME_STACK_IS_DOUBLE_STACK_MODE,
        Const.NHL_NAME_STACK_SET_PLAYERS_IN_GROUP,
        Const.NHL_NAME_STACK_ADD_ITEM,
        Const.NHL_NAME_STACK_REMOVE_ITEM,
        Const.NHL_NAME_STACK_SET_TEAM_TO_ITEM,
        Const.NHL_NAME_STACK_SET_EXPOSURE_TO_ITEM,
        Const.NHL_NAME_STACK_SET_PLAYER_TO_ITEM,
        Const.NHL_NAME_STACK_IS_USED,
        Const.HITTERS_STACK_IS_DOUBLE_STACK_MODE,
        Const.SET_HITTER_STACK_PLAYERS_IN_GROUP,
        Const.HITTERS_STACK_ADD_ITEM,
        Const.HITTERS_STACK_REMOVE_ITEM,
        Const.HITTERS_STACK_SET_TEAM_TO_ITEM,
        Const.HITTERS_STACK_SET_EXPOSURE_TO_ITEM,
        Const.HITTERS_STACK_SET_PLAYER_TO_ITEM,
        Const.HITTERS_STACK_SET_DATA_FROM_STORAGE,
        Const.USE_HITTERS_STACK,
        Const.NON_CONTROLLED_HITTER_STACKING_IS_USED,
        Const.SET_GROUPS_OF_STACKS,
        Const.SET_TEAM_NAME_STACKING_GROUPS,
        Const.RESET_GROUPS_OF_STACKS,

        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    sportConfig: filterActions(sportConfig, [
        Const.GET_SPORT_CONFIG_REQUEST,
        Const.GET_SPORT_CONFIG_SUCCESS,
        Const.GET_SPORT_CONFIG_FAILURE,
        Const.FILTER_BY_SPORT,
        Const.FILTER_BY_SITE,
        Const.FILTER_BY_GAME_TYPE,
        Const.FILTER_BY_SLATE,
        Const.FILTER_BY_MODE,
        Const.UPDATE_MAX_SALARY,
    ]),
    lineupGenerator: filterActions(lineupGenerator, [
        Const.SET_GENERATOR_TYPE,
        Const.SET_SHOW_PLAYERS_EXPOSURE_WHILE_OPTIMIZED,
        Const.SET_RELAX_BUILD_RULES,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    reset: filterActions(reset, [Const.RESET_ALL_SETTINGS]),
    messagesData: filterActions(messagesData, [Const.SET_MESSAGES, Const.SET_SPORT_MESSAGE]),
    lineupTeamsCombinations: filterActions(lineupTeamsCombinations, [
        Const.SET_EXPOSURE_MAX_OF_TEAM_COMBINATIONS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    lineupTeamsStacks: filterActions(lineupTeamsStacks, [
        Const.SET_EXPOSURE_MAX_OF_TEAM_STACKS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    usedTeams: filterActions(usedTeams, [
        Const.SET_EXPOSURE_MAX_OF_USED_TEAM,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    correlationStacking: filterActions(correlationStacking, [
        Const.CORRELATION_STACKING_SET_DATA_FROM_STORAGE,
        Const.CORRELATION_STACKING_SET_IS_USED,
        Const.CORRELATION_STACKING_SET_UNIVERSAL_RULE,
        Const.CORRELATION_STACKING_ADD_ITEM,
        Const.CORRELATION_STACKING_SET_BOOST,
        Const.CORRELATION_STACKING_SET_MIN_EXPOSURE,
        Const.CORRELATION_STACKING_SET_KEY_PLAYER_ID,
        Const.CORRELATION_STACKING_SET_STACK_PLAYERS,
        Const.CORRELATION_STACKING_PATCH_STACK_PLAYER,
        Const.CORRELATION_STACKING_SET_FIRST_TEAM_AT_LEAST_PLAYERS,
        Const.CORRELATION_STACKING_SET_FIRST_TEAM_AT_MOST_PLAYERS,
        Const.CORRELATION_STACKING_SET_SECOND_TEAM_AT_LEAST_PLAYERS,
        Const.CORRELATION_STACKING_SET_SECOND_TEAM_AT_MOST_PLAYERS,
        Const.CORRELATION_STACKING_SET_STACK_TYPE,
        Const.CORRELATION_STACKING_SET_SECONDARY_STACK_TYPE,
        Const.CORRELATION_STACKING_SET_SECONDARY_STACK_COMBINATION_TYPE,
        Const.CORRELATION_STACKING_SET_UNIVERSAL_STACK_COMBINATION_TYPE,
        Const.CORRELATION_STACKING_REMOVE_ITEM,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
        Const.TEAM_NAME_STACKING_SET_IS_USED,
        Const.PLAYER_POSITION_STACKING_SET_IS_USED,
        Const.CORRELATION_STACKING_RESTRICT_PLAYERS,
        Const.LOCKING_SET_PLAYERS,
        Const.CORRELATION_STACKING_COMBO_SET_EXPOSURE_MAX,
        Const.CORRELATION_STACKING_SET_COMBINATION_GROUPS,
    ]),
    keyPlayerStacking: filterActions(keyPlayerStacking, [
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
        Const.KEY_PLAYER_STACKING_COMBO_SET_EXPOSURE_MAX,
        Const.KEY_PLAYER_STACKING_SET_COMBINATION_GROUPS,
    ]),
    runSettings: filterActions(runSettings, [Const.SAVE_RUN_SETTINGS]),
    playersLock: filterActions(playersLock, [
        Const.LOCKING_SET_PLAYERS,
        Const.EXCLUSION_SET_PLAYERS,
        Const.CORRELATION_STACKING_RESTRICT_PLAYERS,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_RESTRICT_PLAYERS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    playersExclusion: filterActions(playersExclusion, [
        Const.EXCLUSION_SET_PLAYERS,
        Const.LOCKING_SET_PLAYERS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    playersSympathy: filterActions(playersSympathy, [
        Const.SYMPATHY_SET_PLAYERS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    pointsBoundary: filterActions(pointsBoundary, [
        Const.POINTS_BOUNDARY_SET_INNER,
        Const.POINTS_BOUNDARY_SET_OUTER,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    salaryBoundary: filterActions(salaryBoundary, [
        Const.SALARY_BOUNDARY_SET_INNER,
        Const.SALARY_BOUNDARY_SET_OUTER,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    salaryCap: filterActions(salaryCap, [
        Const.SALARY_CAP_SET_INNER,
        Const.SALARY_CAP_SET_OUTER,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    projectedOwnershipCap: filterActions(projectedOwnershipCap, [
        Const.PROJECTED_OWNERSHIP_CAP_SET_INNER,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    teamNameStacking: filterActions(teamNameStacking, [
        Const.TEAM_NAME_STACKING_SET_TEAM_OPTIONS,
        Const.TEAM_NAME_STACKING_SET_ALL_TEAM_OPTIONS_ENABLED_STATUS,
        Const.TEAM_NAME_STACKING_SET_MAX_PLAYERS_FOR_TEAMS,
        Const.TEAM_NAME_STACKING_SET_DATA_FROM_STORAGE,
        Const.TEAM_NAME_STACKING_SET_IS_USED,
        Const.TEAM_NAME_STACKING_SET_IS_WIDGET_HIDDEN,
        Const.CORRELATION_STACKING_SET_IS_USED,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    playerNameStacking: filterActions(playerNameStacking, [
        Const.PLAYER_NAME_STACKING_SET_DATA_FROM_STORAGE,
        Const.PLAYER_NAME_STACKING_SET_IS_USED,
        Const.PLAYER_NAME_STACKING_ADD_ITEM,
        Const.PLAYER_NAME_STACKING_REMOVE_ITEM,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    playerPositionStacking: filterActions(playerPositionStacking, [
        Const.PLAYER_POSITION_STACKING_SET_DATA_FROM_STORAGE,
        Const.PLAYER_POSITION_STACKING_SET_IS_USED,
        Const.PLAYER_POSITION_STACKING_ADD_ITEM,
        Const.PLAYER_POSITION_STACKING_REMOVE_ITEM,
        Const.PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_IS_USED,
        Const.PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_IS_FORCED,
        Const.PLAYER_POSITION_STACKING_SET_ALLOW_OVERLAP_PRIMARY_AND_SECONDARY_STACKS,
        Const.PLAYER_POSITION_STACKING_SET_SECONDARY_STACK_COMBINATION_TYPE,
        Const.CORRELATION_STACKING_SET_IS_USED,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    cptPositionStacking: filterActions(cptPositionStacking, [
        Const.CAP_POSITION_STACKING_SET_DATA_FROM_STORAGE,
        Const.CAP_POSITION_STACKING_SET_IS_USED,
        Const.CAP_POSITION_STACKING_ADD_ITEM,
        Const.CAP_POSITION_STACKING_REMOVE_ITEM,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    optimizationConfig: filterActions(optimizationConfig, [Const.OPTIMIZATION_SET_CONFIG]),
    optimization: filterActions(optimization, [
        Const.OPTIMIZATION_START,
        Const.OPTIMIZATION_TERMINATE,
        Const.SET_STATUS_OF_LINEUPS_IS_FILLED,
    ]),
    usedPlayers: filterActions(usedPlayers, [
        Const.USED_PLAYERS_SET_FILTER_POSITION,
        Const.USED_PLAYERS_SET_FILTER_TIER,
        Const.USED_PLAYERS_SET_FILTER_SHOWDOWN,
        Const.USED_PLAYERS_SET_FILTER_SINGLE_GAME,
        Const.RESET_ALL_SETTINGS,
        Const.RESET_LINEUP_PLAYER_FILTER,
        Const.SET_LINEUPS_USED_PLAYERS,
        Const.UNSET_LINEUPS,
        Const.SHOW_UNEXPOSED_PLAYERS_IN_EXPOSURE_BOX,
    ]),
    modesConfig: filterActions(modesConfig, [
        Const.MODES_CONFIG_INIT,
        Const.FILTER_BY_SPORT,
        Const.FILTER_BY_SITE,
        Const.FILTER_BY_GAME_TYPE,
    ]),
    playerSettingPopup: filterActions(playerSettingPopup, [Const.PLAYER_SETTING_POPUP_SET_STATE]),
    teamsInfo: filterActions(teamsInfo, [
        Const.SET_TEAMS,
        Const.FILTER_BY_MODE,
        Const.FILTER_BY_SITE,
        Const.FILTER_BY_SPORT,
        Const.FILTER_BY_GAME_TYPE,
        Const.FILTER_BY_SLATE,
    ]),
    exposureMode: filterActions(exposureMode, [
        Const.SET_EXPOSURE_MODE,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    projectionPointsType: filterActions(projectionPointsType, [
        Const.SET_PROJECTION_POINTS_TYPE,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    userPointsType: filterActions(userPointsType, [
        Const.SET_USER_POINTS_TYPE,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    uniquePlayersQuantity: filterActions(uniquePlayersQuantity, [
        Const.SET_UNIQUE_PLAYERS_QUANTITY,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    rangeOfOutcomes: filterActions(rangeOfOutcomes, [
        Const.SET_RANGE_OF_OUTCOMES,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    rangeOfOutcomesByPositions: filterActions(rangeOfOutcomesByPositions, [
        Const.SET_RANGE_OF_OUTCOMES_BY_POSITIONS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    lineupsQuantity: filterActions(lineupsQuantity, [
        Const.SET_LINEUPS_QUANTITY,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    nonControlledHitterStacking: filterActions(nonControlledHitterStacking, [
        Const.NON_CONTROLLED_HITTER_STACKING_IS_USED,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_RESTRICT_PLAYERS,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_COMBO_IS_CHECKED,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_COMBO_EXPOSURE,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_PLAYERS_QUANTITY,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_TEAMS,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_STACK_TEAMS_IS_CHECKED,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_STACK_TEAMS_EXPOSURE,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_BATTING_ORDER,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_TEAM_IS_CHECKED,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_TEAM_EXPOSURE,
        Const.NON_CONTROLLED_HITTER_STACKING_SET_DATA_FROM_STORAGE,
        Const.NON_CONTROLLED_HITTER_STACKING_MIRROR_STACK,
        Const.GET_GAMES_SUCCESS,
        Const.LOCKING_SET_PLAYERS,
        Const.USE_HITTERS_STACK,
        Const.FILTER_BY_SITE,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    singlegameForcedStacking: filterActions(singlegameForcedStacking, [
        Const.SINGLEGAME_FORCED_STACKING_IS_USED,
        Const.SINGLEGAME_FORCED_STACKING_SET_COMBO_IS_CHECKED,
        Const.SINGLEGAME_FORCED_STACKING_SET_COMBO_EXPOSURE,
        Const.GET_GAMES_SUCCESS,
        // Const.FILTER_BY_SITE,
        Const.FILTER_BY_SPORT,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    randomTeamStacking: filterActions(randomTeamStacking, [
        Const.RANDOM_TEAM_STACKING_IS_USED,
        Const.RANDOM_TEAM_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY,
        Const.RANDOM_TEAM_STACKING_SET_CAPTAIN_IS_FORCED,
        Const.RANDOM_TEAM_STACKING_SET_DISALLOWED_POSITIONS_IS_USED,
        Const.RANDOM_TEAM_STACKING_SET_DISALLOWED_POSITIONS,
        Const.RANDOM_TEAM_STACKING_SET_PLAYERS_QUANTITY,
        Const.RANDOM_TEAM_STACKING_SET_TEAMS,
        Const.RANDOM_TEAM_STACKING_SET_STACK_TEAMS_IS_CHECKED,
        Const.RANDOM_TEAM_STACKING_SET_STACK_TEAMS_EXPOSURE,
        Const.RANDOM_TEAM_STACKING_SET_TEAM_IS_CHECKED,
        Const.RANDOM_TEAM_STACKING_SET_TEAM_EXPOSURE,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
        Const.GET_GAMES_SUCCESS,
    ]),
    competitionStacking: filterActions(competitionStacking, [
        Const.COMPETITION_STACKING_SET_IS_USED,
        Const.COMPETITION_STACKING_ADD_ITEM,
        Const.COMPETITION_STACKING_SET_COMPETITION,
        Const.COMPETITION_STACKING_SET_EXPOSURE,
        Const.COMPETITION_STACKING_REMOVE_ITEM,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    dominatorStacking: filterActions(dominatorStacking, [
        Const.DOMINATOR_STACKING_SET_IS_USED,
        Const.DOMINATOR_STACKING_ADD_ITEM,
        Const.DOMINATOR_STACKING_REMOVE_ITEM,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    opposingPitchers: filterActions(opposingPitchers, [
        Const.OPPOSING_PITCHERS_SET_DATA_FROM_STORAGE,
        Const.OPPOSING_PITCHERS_SET_IS_ALLOWED,
        Const.OPPOSING_PITCHERS_SET_ALLOWED_QUANTITY,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    projectedOwnershipForce: filterActions(projectedOwnershipForce, [
        Const.PROJECTED_OWNERSHIP_FORCE_SET_IS_ENABLED,
        Const.PROJECTED_OWNERSHIP_FORCE_SET_RANGE,
        Const.PROJECTED_OWNERSHIP_FORCE_SET_IGNORED_POSITION,
        Const.PROJECTED_OWNERSHIP_FORCE_SET_SUB_PERCENT,
        Const.PROJECTED_OWNERSHIP_FORCE_SET_DATA_FROM_STORAGE,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    playerCombinationStacking: filterActions(playerCombinationStacking, [
        Const.PLAYER_COMBINATION_STACKING_SET_IS_USED,
        Const.PLAYER_COMBINATION_STACKING_ADD_ITEM,
        Const.PLAYER_COMBINATION_STACKING_REMOVE_ITEM,
        Const.PLAYER_COMBINATION_STACKING_SET_DATA_FROM_STORAGE,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    filterLineupsByPlayer: filterActions(filterLineupsByPlayer, [
        Const.FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER,
        Const.FILTER_LINEUPS_BY_TEAM_COMBINATIONS_SET_COMBO,
        Const.FILTER_LINEUPS_BY_CORRELATION_STACK_COMBINATIONS_SET_COMBO,
        Const.FILTER_LINEUPS_BY_KEY_PLAYER_STACK_COMBINATIONS_SET_COMBO,
        Const.UNSET_LINEUPS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    lineupPlayerMap: filterActions(lineupPlayerMap, [
        Const.SET_LINEUP_PLAYER_MAP,
        Const.UNSET_LINEUPS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    nhlTeamStacking: filterActions(nhlTeamStacking, [
        Const.NHL_TEAM_STACKING_IS_USED,
        Const.NHL_TEAM_STACKING_SET_RESTRICT_PLAYERS,
        Const.NHL_TEAM_STACKING_SET_COMBO_IS_CHECKED,
        Const.NHL_TEAM_STACKING_SET_COMBO_EXPOSURE,
        Const.NHL_TEAM_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY,
        Const.NHL_TEAM_STACKING_SET_TEAMS_ARE_FORCED_TO_STACKING,
        Const.NHL_TEAM_STACKING_SET_TEAMS,
        Const.NHL_TEAM_STACKING_SET_STACK_TEAMS_IS_CHECKED,
        Const.NHL_TEAM_STACKING_SET_STACK_TEAMS_EXPOSURE,
        Const.NHL_TEAM_STACKING_SET_TEAM_LINE_GROUP_IS_CHECKED,
        Const.NHL_TEAM_STACKING_SET_TEAM_LINE_GROUPS,
        Const.NHL_TEAM_STACKING_SET_TEAM_PP_LINE_IS_CHECKED,
        Const.NHL_TEAM_STACKING_SET_TEAM_PP_LINES,
        Const.NHL_TEAM_STACKING_SET_TEAM_IS_CHECKED,
        Const.NHL_TEAM_STACKING_SET_TEAM_EXPOSURE,
        Const.NHL_TEAM_STACKING_SET_DATA_FROM_STORAGE,
        Const.NHL_TEAM_STACKING_MIRROR_STACK,
        Const.NHL_TEAM_STACKING_SET_TEAM_DEFENSEMAN_IS_INCLUDED,
        Const.GET_GAMES_SUCCESS,
        Const.FILTER_BY_SITE,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
        Const.NHL_LEGACY_TEAM_STACKING_IS_USED,
    ]),
    nhlLegacyTeamStacking: filterActions(nhlLegacyTeamStacking, [
        Const.NHL_LEGACY_TEAM_STACKING_IS_USED,
        Const.NHL_LEGACY_TEAM_STACKING_SET_RESTRICT_PLAYERS,
        Const.NHL_LEGACY_TEAM_STACKING_SET_COMBO_IS_CHECKED,
        Const.NHL_LEGACY_TEAM_STACKING_SET_COMBO_EXPOSURE,
        Const.NHL_LEGACY_TEAM_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY,
        Const.NHL_LEGACY_TEAM_STACKING_SET_TEAMS_ARE_FORCED_TO_STACKING,
        Const.NHL_LEGACY_TEAM_STACKING_SET_TEAMS,
        Const.NHL_LEGACY_TEAM_STACKING_SET_STACK_TEAMS_IS_CHECKED,
        Const.NHL_LEGACY_TEAM_STACKING_SET_STACK_TEAMS_EXPOSURE,
        Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_LINE_GROUP_IS_CHECKED,
        Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_LINE_GROUPS,
        Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_PP_LINE_IS_CHECKED,
        Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_PP_LINES,
        Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_IS_CHECKED,
        Const.NHL_LEGACY_TEAM_STACKING_SET_TEAM_EXPOSURE,
        Const.NHL_LEGACY_TEAM_STACKING_SET_DATA_FROM_STORAGE,
        Const.NHL_LEGACY_TEAM_STACKING_MIRROR_STACK,
        Const.GET_GAMES_SUCCESS,
        Const.FILTER_BY_SITE,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
        Const.NHL_TEAM_STACKING_IS_USED,
    ]),
    f1PerTeamDriverLimits: filterActions(f1PerTeamDriverLimits, [
        Const.F1_PER_TEAM_DRIVER_LIMITS_SET_IS_USED,
        Const.F1_PER_TEAM_DRIVER_LIMITS_SET_FOR_TEAM,
        Const.F1_PER_TEAM_DRIVER_LIMITS_SET_FOR_TEAMS,
        Const.FILTER_BY_SITE,
        Const.RESET_ALL_SETTINGS,
    ]),
    filterLineupsByTeamCombinations: filterActions(filterLineupsByTeamCombinations, [
        Const.FILTER_LINEUPS_BY_TEAM_COMBINATIONS_SET_COMBO,
        Const.FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER,
        Const.UNSET_LINEUPS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    lineupTeamCombinationsMap: filterActions(lineupTeamCombinationsMap, [
        Const.SET_LINEUP_TEAM_COMBINATIONS_MAP,
        Const.UNSET_LINEUPS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    filterLineupsByCorrelationStackCombinations: filterActions(filterLineupsByCorrelationStackCombinations, [
        Const.FILTER_LINEUPS_BY_CORRELATION_STACK_COMBINATIONS_SET_COMBO,
        Const.FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER,
        Const.UNSET_LINEUPS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    lineupCorrelationStackCombinationsMap: filterActions(lineupCorrelationStackCombinationsMap, [
        Const.SET_LINEUP_CORRELATION_STACK_COMBINATIONS_MAP,
        Const.UNSET_LINEUPS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    projectionBoostRule: filterActions(projectionBoostRule, [
        Const.PROJECTION_BOOST_RULE_SET_DATA_FROM_STORAGE,
        Const.PROJECTION_BOOST_RULE_SET_IS_USED,
        Const.PROJECTION_BOOST_RULE_ADD_ITEM,
        Const.PROJECTION_BOOST_RULE_REMOVE_ITEM,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    playerGroupingsSwitch: filterActions(playerGroupingsSwitch, [
        Const.PLAYER_GROUPINGS_SWITCH_IS_ON,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    filterLineupsByKeyPlayerStackCombinations: filterActions(filterLineupsByKeyPlayerStackCombinations, [
        Const.FILTER_LINEUPS_BY_KEY_PLAYER_STACK_COMBINATIONS_SET_COMBO,
        Const.FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER,
        Const.UNSET_LINEUPS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    lineupKeyPlayerStackCombinationsMap: filterActions(lineupKeyPlayerStackCombinationsMap, [
        Const.SET_LINEUP_KEY_PLAYER_STACK_COMBINATIONS_MAP,
        Const.UNSET_LINEUPS,
        Const.RESET_ALL_SETTINGS,
        Const.FILTER_BY_SLATE,
    ]),
    playersDropzone: filterActions(playersDropzone, [
        Const.SHOW_DROPZONE,
        Const.HIDE_DROPZONE,
        Const.DROPZONE_IS_LOADING,
        Const.DROPZONE_IS_NOT_LOADING,
    ]),
    theme: filterActions(theme, [Const.TOGGLE_THEME]),
};

export default combineReducers(reducers);
